"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.darkStyles = void 0;
exports.darkStyles = {
    body: {
        background: 'rgb(32, 32, 32)',
    },
    rbgcpInputLabel: {
        color: 'rgb(212, 212, 212)',
    },
    rbgcpControlBtnWrapper: {
        background: 'rgb(54, 54, 54)',
    },
    rbgcpInput: {
        border: 'none',
        color: 'white',
        background: 'rgb(54, 54, 54)',
    },
    rbgcpControlBtn: {
        color: 'rgb(212, 212, 212)',
    },
    rbgcpControlIcon: {
        stroke: 'rgb(212, 212, 212)',
    },
    rbgcpControlIcon2: {
        fill: 'rgb(212, 212, 212)',
    },
    rbgcpControlInput: {
        color: 'white',
    },
    rbgcpControlBtnSelected: {
        background: 'black',
        color: '#568cf5',
    },
    rbgcpDegreeIcon: {
        color: 'rgb(212, 212, 212)',
    },
    rbgcpColorModelDropdown: {
        background: 'rgb(32, 32, 32)',
    },
    rbgcpComparibleLabel: {
        color: 'rgb(212, 212, 212)',
    }
};
